module.exports = __webpack_public_path__ + "static/media/gorra (3).e071fee4.png";